import { ChangeEvent, FC, ReactElement } from 'react';

import { InputProps } from '../../../components';

import './Toggle.scss';

interface ToggleProps extends Omit<InputProps, 'onChange'> {
    label: string;
    onChange: (isChecked: boolean) => void;
    className?: string;
}

export const Toggle: FC<ToggleProps> = ({
    label,
    onChange,
    className = '',
    ...toggleProps
}): ReactElement => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
        onChange(event.currentTarget.checked);
    };

    return (
        <label className={`toggle ${className}`}>
            <input
                {...toggleProps}
                type="checkbox"
                onChange={handleChange}
                className="toggle__input"
            />

            <span className="toggle__handle-wrapper">
                <span className="toggle__handle" />

                <span className="toggle__accent-wrapper">
                    <span className="toggle__accent" />
                </span>
            </span>

            <span className="toggle__label">{label}</span>
        </label>
    );
};
